export default __webpack_public_path__ + "static/media/image1.1a7a7a39.png";